import { Popper } from 'patsnap-biz';
import { useDisposes } from './use-disposes';
import { Disposable } from '@patsnap/tahiti-core';
import _ from 'lodash';
export const useTippyTooltip = () => {
    function getContent(reference) {
        return reference.getAttribute('data-tippy-content');
    }
    const { disposes } = useDisposes();
    const initTippyTooltip = () => {
        // @ts-ignore
        const instance = Popper.tippyJs.delegate('body', {
            target: '[data-tippy-content]',
            content: getContent,
            theme: 'light',
            arrow: false,
            maxWidth: 500,
            allowHTML: true,
            delay: [500, 0],
            onShow: (instance) => {
                const content = getContent(instance.reference);
                if (!content) {
                    return false;
                }
                instance.setContent(content);
            },
        });
        disposes.push(Disposable.create(() => {
            const instances = _.isArray(instance) ? instance : [instance];
            instances.forEach((inst) => {
                inst.destroy();
            });
        }));
    };
    return {
        initTippyTooltip,
    };
};
